import merchantOfferModal from './merchantOfferModal';

export default merchantOfferModal;
